<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name, maxHeight]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        v-if="content"
        :class="[`${name}__grid-item`, `${name}__content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 4, width: 19 },
          { size: 5, x: 4, width: 19 },
        ]"
      >
        <a-copy :cms="cms" :class="`${name}__copy`" />
      </grid-item>
    </grid>

    <component
      :is="item.component"
      v-for="item in cms.battenberg"
      :key="item._uid"
      v-editable="item"
      :cms="item"
      :class="`${name}__battenberg`"
    />
  </section>
</template>

<script>
import ASvgLogoX9 from '@/components/atoms/a-svgs/a-svg-logo-x9'
import data from '~/components/organisms/o-health/o-health-text-hero.data'
import Colors from '~/mixins/colors'
export default {
  components: { ASvgLogoX9 },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return process.env.NODE_ENV === 'development' ? { ...data } : {}
      },
    },
  },

  data() {
    return {
      name: 'o-health-text-hero',
      show: false,
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#C33CA8',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#212121'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#FFFFFF'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--filter': this.cms.filter || null,
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
    maxHeight() {
      return this.cms.maxHeight ? 'max-height' : ''
    },
    content() {
      return this.cms.heading || this.cms.copy
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-health-text-hero {
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  display: grid;
  position: relative;
  min-height: 205px;
  &.max-height {
    height: calc(100vh - 73px);
    min-height: 693px;
    max-height: 820px;
  }

  &__grid {
    align-content: center;
  }

  &__content {
    z-index: 1;
    padding: 90px 0 106px 0;
  }

  &__battenberg {
    position: absolute;
    top: 0;
    left: 0;
    width: 102px;
    height: 102px;
  }

  ::v-deep a,
  ::v-deep .a-cta,
  ::v-deep button {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep img {
    filter: var(--filter);
  }
}

@include media-breakpoint-up(lg) {
  .o-health-text-hero {
    &__battenberg {
      width: 205px;
      height: 205px;
    }
  }
}
</style>
